import styled from 'styled-components';

export const BreadcrumbDiv = styled.div`
  margin: 1rem 1.5rem;
`;
